import type { PaymentLink } from '@/lib/api/payments.api';

type PaymentRowFields = Pick<
  PaymentLink,
  'call_id' | 'contact_id' | 'contact' | 'customer_name' | 'customer_email' | 'phone_number'
>;

/** Where "view conversation" goes: the call when there is one, else the contact's chat. */
export const getPaymentConversationLink = (
  payment: PaymentRowFields,
): { to: string; label: string } | null => {
  if (payment.call_id) return { to: `/calls/${payment.call_id}`, label: 'View call' };
  const contactId = payment.contact_id ?? payment.contact?.id;
  if (contactId) return { to: `/sales-console/${contactId}`, label: 'View conversation' };
  return null;
};

/**
 * Customer details: name and email prefer the linked contact, falling back to the payment's own
 * fields. Phone prefers the number the link was sent to.
 */
export const getPaymentCustomer = (
  payment: PaymentRowFields,
): { name: string | null; phone: string | null; email: string | null } => ({
  name: payment.contact?.name || payment.customer_name || null,
  phone: payment.phone_number || payment.contact?.phone || null,
  email: payment.contact?.email || payment.customer_email || null,
});
